module.exports = ".caption {\n    padding-top: 6px;\n    padding-bottom: 12px;\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    color: #959695;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/data-view-header/data-view-header.component.css
// module id = ./src/app/components/data-view-header/data-view-header.component.css
// module chunks = main